module.exports = __webpack_public_path__ + "static/media/010_Version5AggregateViewCollapsed.cd6a93d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/backtrace/010_Version5AggregateViewCollapsed.png
// module id = 378
// module chunks = 0